import { useState, useEffect } from "react";
import CakeOrdersTable from "./CakeOrdersTable";
import SearchBar from "../common/SearchBar";
import { useCakeOrders } from '../../hooks';
import styles from './CakeOrdersTable.module.css';

export default function SearchCakeOrders() {
    const [fetchAll, setFetchAll] = useState(false);
    const { orders: cakeOrders, loading } = useCakeOrders(fetchAll);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [sortOrder, setSortOrder] = useState('asc');
    const [seeAll, setSeeAll] = useState(true);

    useEffect(() => {
        setFilteredOrders(cakeOrders);
    }, [cakeOrders]);

    function handleSeeTodayOnly() {
        const today = new Date();
        const todayString = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
        const filteredData = cakeOrders.filter(cake => cake.date === todayString);
        setFilteredOrders(filteredData);
    }

    function onSearch(query) {
        if (query === '') {
            setFilteredOrders(cakeOrders);
            return;
        }
        const q = query.toLowerCase();
        const filteredData = cakeOrders.filter(cake =>
            (cake.firstName || '').toLowerCase().includes(q) ||
            (cake.cashier || '').toLowerCase().includes(q) ||
            (cake.date || '').toLowerCase().includes(q) ||
            (cake.phoneNumber || '').toLowerCase().includes(q) ||
            (cake.message || '').toLowerCase().includes(q) ||
            (cake.image || '').toLowerCase().includes(q)
        );
        setFilteredOrders(filteredData);
    }

    return (
        <div className="basicContainer">
            <div className={styles.searchResultsCake}>
                <h1>Ordenes de Pastel</h1>
                <hr />
                <SearchBar onSearch={onSearch} />
                <div className={styles.sortOptions}>
                    <label>
                        <input
                            type="radio"
                            name="sortDate"
                            value="asc"
                            checked={sortOrder === 'asc'}
                            onChange={(e) => {
                                setSortOrder(e.target.value);
                                setFilteredOrders([...filteredOrders].sort((a, b) =>
                                    a.date.localeCompare(b.date)
                                ));
                            }}
                        />
                        Fecha ↑
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="sortDate"
                            value="desc"
                            checked={sortOrder === 'desc'}
                            onChange={(e) => {
                                setSortOrder(e.target.value);
                                setFilteredOrders([...filteredOrders].sort((a, b) =>
                                    b.date.localeCompare(a.date)
                                ));
                            }}
                        />
                        Fecha ↓
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="sortName"
                            value="true"
                            checked={seeAll}
                            onChange={() => {
                                setSeeAll(true);
                                setFilteredOrders(cakeOrders);
                            }}
                        />
                        Ver Todas
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="sortName"
                            value="false"
                            checked={!seeAll}
                            onChange={() => {
                                setSeeAll(false);
                                handleSeeTodayOnly();
                            }}
                        />
                        Ver Hoy
                    </label>
                </div>
                <CakeOrdersTable
                    loading={loading}
                    cakeOrders={filteredOrders}
                    setCakeOrders={() => {}}
                />
                {!fetchAll && (
                    <button className="fetchAllButton" onClick={() => setFetchAll(true)}>
                        Ver Todas las Ordenes
                    </button>
                )}
            </div>
        </div>
    );
}
